/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityCustomTagFacility } from './FacilityCustomTagFacility';
import {
    FacilityCustomTagFacilityFromJSON,
    FacilityCustomTagFacilityFromJSONTyped,
    FacilityCustomTagFacilityToJSON,
} from './FacilityCustomTagFacility';

/**
 * 
 * @export
 * @interface FacilityCustomTag
 */
export interface FacilityCustomTag {
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTag
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FacilityCustomTag
     */
    facility_use_count: number;
    /**
     * 
     * @type {Array<FacilityCustomTagFacility>}
     * @memberof FacilityCustomTag
     */
    facilities: Array<FacilityCustomTagFacility>;
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTag
     */
    date_created: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTag
     */
    date_modified: string | null;
    /**
     * 
     * @type {object}
     * @memberof FacilityCustomTag
     */
    updated_by_user?: object;
}

/**
 * Check if a given object implements the FacilityCustomTag interface.
 */
export function instanceOfFacilityCustomTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_use_count" in value;
    isInstance = isInstance && "facilities" in value;
    isInstance = isInstance && "date_created" in value;
    isInstance = isInstance && "date_modified" in value;

    return isInstance;
}

export function FacilityCustomTagFromJSON(json: any): FacilityCustomTag {
    return FacilityCustomTagFromJSONTyped(json, false);
}

export function FacilityCustomTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityCustomTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_use_count': json['facility_use_count'],
        'facilities': ((json['facilities'] as Array<any>).map(FacilityCustomTagFacilityFromJSON)),
        'date_created': json['date_created'],
        'date_modified': json['date_modified'],
        'updated_by_user': !exists(json, 'updated_by_user') ? undefined : json['updated_by_user'],
    };
}

export function FacilityCustomTagToJSON(value?: FacilityCustomTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'facility_use_count': value.facility_use_count,
        'facilities': ((value.facilities as Array<any>).map(FacilityCustomTagFacilityToJSON)),
        'date_created': value.date_created,
        'date_modified': value.date_modified,
        'updated_by_user': value.updated_by_user,
    };
}

